<template>
    <div class="row">
        <div class="cell">
            <h3>{{ item.name }}</h3>
            <h4>{{ item.sub_name}}</h4>
        </div>
        <div class="cell">
            <h3>CHF {{ formatPrice(item.price) }}</h3>
            <span>+ CHF {{ item.price2 }}</span>
        </div>
        <div class="cell" id="id"><img src="../../assets/images/next.png"></div>
    </div>

</template>

<style lang="scss">
    @import '../../assets/css/style';
    .table .row {
        margin: 0;
        padding: 11px 0;
        border-bottom: 1px solid $line_color;

        .cell {
            font-size: 1.4rem;


            &:nth-of-type(1),
            &:nth-of-type(2) {
                padding-top: 2px;
                padding-left: 5px;

                h3 {
                    font-family: "SF UI Text Light";
                    color: #252226;
                    font-weight: 600;
                    margin-bottom: 0px;
                    font-size: 1.5rem;
                }
            }

            &:nth-of-type(1) {
                width: 63%;

                h4 {
                    color: #4a4a4a;
                    font-size: 1.3rem;
                    margin-top: 2px;
                }

            }

            &:nth-of-type(2) {
                width: 33%;
                text-align: right;

                h3{
                    text-align: right;
                }

                span {
                    font-weight: 400;
                    color: #51ac30;
                    font-size: 1.3rem;
                }
            }

            &:nth-of-type(3) {
                width: 4%;
                color: #838289;
                font-weight: 500;
                padding: 0px;
                padding-left: 10px;
            }
        }
    }
</style>

<script>
    export default {
        props: ['item'],
        data() {
            return {
                quantity: 0
            }
        },
        methods: {
            formatPrice(value) {
                return value.toFixed(2);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/meine_trends/Item.vue